import { render } from "./LayoutHearder.vue?vue&type=template&id=6327f122&scoped=true"
import script from "./LayoutHearder.vue?vue&type=script&lang=js"
export * from "./LayoutHearder.vue?vue&type=script&lang=js"

import "./LayoutHearder.vue?vue&type=style&index=0&id=6327f122&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6327f122"]])

export default __exports__